import { jsx as _jsx } from "react/jsx-runtime";
import { session } from '../logic/session';
import Login from './Login';
import TodoList from './TodoList';
const App = () => {
    if (session.info.isLoggedIn) {
        return (_jsx(TodoList, { webId: session.info.webId }));
    }
    else {
        return (_jsx(Login, {}));
    }
};
export default App;
